import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FirstLetterUpperCase } from './firstletteruppercase.pipe';


@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [FirstLetterUpperCase],
  exports: [FirstLetterUpperCase],
})
export class PipeModule {
  static forRoot() {
      return {
          ngModule: PipeModule,
          providers: [],
      };
   }
 }



// WEBPACK FOOTER //
// ./src/app/shared/pipe/pipe.module.ts